/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';

import { withRouter } from 'react-router';

import Status500 from './500';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = { hasError: props.forceShow };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps) {
    const { location: prevLocation } = prevProps;
    const { location } = this.props;

    if (prevLocation.pathname !== location.pathname) {
      this.setState({ hasError: false }); // eslint-disable-line react/no-did-update-set-state
    }
  }

  componentDidCatch(error, info) {
    const { componentStack } = info;
    console.error(error);
    console.groupCollapsed('Component stack');
    console.log(info);
    console.groupEnd();
    window?.Sentry?.captureException?.(error, { contexts: { react: { componentStack } } });
  }

  render() {
    const { fallbackView, children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return fallbackView;
    }
    return children;
  }
}

ErrorBoundary.defaultProps = {
  forceShow: false,
  fallbackView: <Status500 />,
};

ErrorBoundary.propTypes = {
  children: PropTypes.element.isRequired,
  fallbackView: PropTypes.node,
  forceShow: PropTypes.bool,
  location: ReactRouterPropTypes.location.isRequired,
};

export default withRouter(ErrorBoundary);
